import { computed, observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { getOmniData } from '@src/services/omni-api';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import { useEffect } from 'react';

const styles = require('./index.less');

let swiperImgRef = null;
let swiperRef = null;
let firstLoad = true;
let stopChange = false;
class FeatureStore {
  @observable config = {};
  @observable isActive = false;
  @observable showFeature = false;
  @observable firstLoad = true;
  @observable firstLoad2 = true;
  @observable changeType = 'default'; // 切换类型
  @observable stopChange = false;
  @observable showSwiper = true;

  @observable swiperList = [];
  @observable currentImgIndex = 0;
  @observable currentIndex = 0;

  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 20,
      centeredSlides: true,
      watchSlidesVisibility: true, //防止不可点击
      on: {
        init: function() {
          swiperRef = this;
          // that.showFeature = true;
        },
        slideChangeTransitionStart: function() {
          that.currentIndex = this.realIndex;
        },
        resize: function() {
          this.update();
        },
        click: function() {
          const visibleSlidesIndexes = this.visibleSlidesIndexes;
          const clickedIndex = this.clickedIndex;
          const foundIndex = visibleSlidesIndexes.findIndex(index => index === clickedIndex);
          if (foundIndex > -1) {
            if (foundIndex < 2) {
              this.slidePrev();
            } else if (foundIndex > 2) {
              this.slideNext();
            }
          }
        }
      }
    };
  }

  @computed
  get paramsImg() {
    const that = this;
    return {
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      // thumbs: {
      //   swiper: swiperRef
      // },
      on: {
        init: function() {
          swiperImgRef = this;
        }
      }
    };
  }

  changeSwiper = direction => {
    this.changeType = 'click';
    if (direction === 'prev') {
      swiperRef?.slidePrev();
    } else if (direction === 'next') {
      swiperRef?.slideNext();
    } else {
      swiperRef?.slideToLoop(direction);
    }
  };

  getFeatureData = async () => {
    try {
      const res = await getOmniData('channel_cat_f08e881b', [
        {
          dataSourceId: 'ds_cat_b894ce49',
          page: 1,
          perPage: 10
        }
      ]);
      const data = res?.ds_cat_b894ce49?.result?.items || [];
      const swiperList = data.map((item, index) => ({
        id: index + 1,
        img: item.feature_img?.[0]?.url || '',
        leftImg: item.desc?.[0]?.url || '',
        thumbImg: item.preview?.[0]?.url || '',
        subTitle: item.preview_able?.[0]?.url || '',
        subTitleDisable: item.preview_disable?.[0]?.url || '',
        title: item.title
      }));
      if (swiperList.length === 5) {
        this.swiperList = [...swiperList, ...swiperList];
      } else {
        this.swiperList = swiperList;
      }

      // this.initSwiper();
    } catch (error) {
      console.log(error);
    }
  };

  initSwiper = () => {
    console.log('initSwiper');
    let thumbsSwiper = new Swiper('#swiperThumbs', {
      slidesPerView: 5,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true
    });
    console.log('thumbsSwiper', thumbsSwiper);
    let swiper = new Swiper('#swiperWrap', {
      loop: true,
      thumbs: {
        swiper: thumbsSwiper
      }
    });
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.getFeatureData();
      // this.showFeature = true;
      setTimeout(() => {
        this.firstLoad = false;
        this.firstLoad2 = false;
      }, 200);
    });

    useEffect(() => {
      // 监听视口变化，节流200ms，变更showSwiper=false,随后为true
      const handleResize = () => {
        this.showSwiper = false;
        setTimeout(() => {
          this.showSwiper = true;
        }, 800);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  }
}
export default FeatureStore;
